import InformationBanner from '@/components/InformationBanner';
import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { PlanMessage } from '@/components/PlanMessage';
import RegularText from '@/components/RegularText';
import { PricingPlan } from '@/constants/enum';
import { handleVisibleBanner, isOpenDeliveryMinimumOrderBannerSelector } from '@/redux/slice/banner.slice';
import { deliveryDisableSelector, deliverySettingSelector, handleSaveDeliverySettings } from '@/redux/slice/delivery.slice';
import { BlockStack, InlineStack, TextField } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { StyledInputPrefix } from '../../styled';
import { sanitizeValue } from '@/helpers';

interface Props {
  currency: string;
}

const DeliveryMinimum = ({ currency }: Props) => {
  const { t } = useTranslation('deliverySettings');
  const deliverySettings = useSelector(deliverySettingSelector);
  const isOpenDeliveryMinimumOrderBanner = useSelector(isOpenDeliveryMinimumOrderBannerSelector);
  const deliveryDisable = useSelector(deliveryDisableSelector);
  const dispatch = useDispatch();

  return (
    <LayoutSettings title={t('deliveryMinimum.title')} helpText={t('deliveryMinimum.desc')}>
      <BlockStack gap={'400'}>
        <BlockStack gap={'100'}>
          <InlineStack align="space-between">
            <RegularText>{t('deliveryMinimum.minimumOrderValue.title')}</RegularText>
            {deliveryDisable.isDisableMinimumOrderValue && <PlanMessage plan={PricingPlan.Essential} />}
          </InlineStack>
          <StyledInputPrefix>
            <TextField
              label={t('deliveryMinimum.minimumOrderValue.title')}
              labelHidden
              type="text"
              value={deliverySettings.minimumOrderAmount ? deliverySettings.minimumOrderAmount.toString() : ''}
              onChange={(value) => {
                const sanitizedValue = sanitizeValue(value);
                if (sanitizedValue !== '') {
                  dispatch(handleSaveDeliverySettings({ minimumOrderAmount: sanitizedValue }));
                } else dispatch(handleSaveDeliverySettings({ minimumOrderAmount: null }));
              }}
              placeholder={t('deliveryMinimum.minimumOrderValue.placeholder')}
              prefix={currency}
              autoComplete="off"
              min={0}
              disabled={deliveryDisable.isDisableMinimumOrderValue}
            />
          </StyledInputPrefix>
        </BlockStack>
        <InformationBanner
          isVisible={isOpenDeliveryMinimumOrderBanner}
          onDismiss={() =>
            dispatch(
              handleVisibleBanner({
                key: 'isOpenDeliveryMinimumOrderBanner',
                value: false,
              }),
            )
          }
        >
          <RegularText>{t('deliveryMinimum.minimumOrderValue.bannerInfo')}</RegularText>
        </InformationBanner>
      </BlockStack>
    </LayoutSettings>
  );
};

export default DeliveryMinimum;
